import React, { useState, useEffect } from 'react';

const SCREAM = 'A'.repeat(250);
const LETTER_INTERVAL_MS = 85;

function FreakOut({ onNavigate }) {
  const [visibleLength, setVisibleLength] = useState(0);

  useEffect(() => {
    if (visibleLength >= SCREAM.length) return;
    const id = setInterval(() => {
      setVisibleLength((n) => Math.min(n + 1, SCREAM.length));
    }, LETTER_INTERVAL_MS);
    return () => clearInterval(id);
  }, [visibleLength]);

  useEffect(() => {
    const id = setTimeout(() => {
      onNavigate?.('lastpanel');
    }, 4000);
    return () => clearTimeout(id);
  }, [onNavigate]);

  return (
    <div className="dashboard freakout">
      <div className="home__center freakout__center">
        <span className="secretpin__title q12__greeting freakout__scream">
          {SCREAM.slice(0, visibleLength).split('').map((char, i) => (
            <span key={i} className="freakout__letter">{char}</span>
          ))}
        </span>
      </div>
    </div>
  );
}

export default FreakOut;
